// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../var/task/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".my-search-token[data-v-7ac2f313]{margin:2px;padding:2px 6px;display:inline-block;border:1px solid #ccc;border-radius:8px;background-color:#fff;font-size:14px}.my-search-token .close[data-v-7ac2f313]{margin-left:5px;padding-left:2px;padding-right:2px;font-size:22px;font-weight:400}", ""]);
// Exports
module.exports = exports;
